<script>

import app from '../web_feathers.js';

import { link } from 'svelte-spa-router';

const queryString = window.location && window.location.search && window.location.search.substring(1)||'';
let urlParams;
if(queryString) urlParams = new URLSearchParams(queryString);
let account = urlParams && urlParams.get('account') ||'';

let password;
let error;
function login(){
	error=null;
	if(!account || !password) return error='You must enter both account information and password.';
	app.login(account,password).catch(e=>error=e);
	}

import Fa from 'svelte-fa'
import { faClipboardList, faSimCard, faMapMarkedAlt, faTools, faChevronRight } from '@fortawesome/free-solid-svg-icons';

</script>
<main>

<form>
	
	<div class="container">
		<div class="row justify-content-md-center">
			<div class="col-lg-6 col-md-8 col-s-12">
				<h2 class="ff-dunbar">Login to your account</h2>
				</div>
				</div>
			<div class="row mt-3 justify-content-md-center">
			<div class="col-lg-6 col-md-8 col-s-12">
				<label for="account" class="ff-dunbar title-2">E-mail, Phone #, or SIM #</label><br>
				<input class="form-control" type="email" name="email" id="account" autocomplete="email" placeholder="E-mail, Phone #, or SIM #" bind:value={account}>
			</div></div>

			<div class="row justify-content-md-center">
			<div class="mt-3 col-lg-6 col-md-8 col-s-12">
				<label for="password" class="ff-dunbar title-2">Password</label>
				<input class="form-control" type="password" name="password" id="password" autocomplete="current-password" placeholder="Password" bind:value={password}>
			</div></div>
			<div class="row justify-content-md-center">
				<div class="mt-3 col-lg-6 col-md-8 col-s-12">
			<button type="submit" class="btn btn-success form-control" on:click|preventDefault={login}>Login <Fa icon={faChevronRight}/></button>
			{#if error}
				<br><br>
				<div class="alert alert-danger">
				{error}
				</div>
				{/if}
			</div></div>
		
			<br>
			<br>
			<div class="row justify-content-md-center">
				<div class="col-s-6 mr-2">
					<a use:link href="/new_password/{account||''}" id="newaccount" class="btn btn-sm" style="background: #d1223e;color:white;">I Need a Password</a>
					</div>
				<div class="col-s-6 ml-2">
					<a use:link href="/new_password/{account||''}" id="newaccount" class="btn btn-sm" style="background: #d1223e;color:white;">Forgot Password</a>
					</div>

			</div>

		</div>
	
		</form>

	</main>